import { render, staticRenderFns } from "./MsgAnalysisRed_package.vue?vue&type=template&id=52e07148&"
import script from "./MsgAnalysisRed_package.vue?vue&type=script&lang=js&"
export * from "./MsgAnalysisRed_package.vue?vue&type=script&lang=js&"
import style0 from "./MsgAnalysisRed_package.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports